export const offerStatuses = ['deleted', 'paused', 'active', 'pending', 'expired'];
export const affiliateStatuses = ['active', 'pending', 'deleted', 'blocked', 'rejected'];
